import React, { createContext, useState, useEffect } from "react";

export const VenueConfigContext = createContext();

export const VenueConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(`${API_URL}/api/config`);
        const data = await res.json();
        setConfig(data);
      } catch (err) {
        console.error("Failed to load config:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return (
    <VenueConfigContext.Provider value={{ config, loading }}>
      {children}
    </VenueConfigContext.Provider>
  );
};